import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from "styled-components";
import useApi, {useApi_file} from "../../hooks/api/axiosInterceptor";

const FileList = styled.ul`
  margin-top: 10px;
  list-style: none;
  padding: 0;
`;
const Wrapper = styled.div`
    height: 100%;
    width: 100%;
    overflow: hidden;
    padding: 2rem;
    
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    text-align: center;
    border: solid 1px #000;
    border-radius: 4px;
`;

const FormGroup = styled.div`
    width: 100%;
    margin-bottom: 20px;
    text-align: left;
`;

const Label = styled.label`
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
`;

const Input = styled.input`
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
`;

const TextArea = styled.textarea`
    width: 100%;
    height: 300px;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    resize: vertical;
`;

const ButtonGroup = styled.div`
    margin-top: 20px;
    display: flex;
    justify-content: center;
    gap: 10px;
`;

const Button = styled.button`
    padding: 8px 16px;
    background-color: ${props => props.primary ? '#007bff' : '#6c757d'};
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    
    &:hover {
        background-color: ${props => props.primary ? '#0069d9' : '#5a6268'};
    }
`;

const EditBoardPost = () => {
    const { category, id } = useParams();
    const navigate = useNavigate();
    const [post, setPost] = useState({ title: '', content: '' });
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [files, setFiles] = useState([]);
    const b_part = category;
    
    // 게시물 데이터 로드
    useEffect(() => {
        const fetchPost = async () => {
            try {
                const response = await useApi.get(`/detail_board?board=${b_part}&id=${id}`);
                if (response.data.result === 'SUCCESS') {
                    const postData = response.data.data;
                    setPost({
                        title: postData.title || '',
                        content: postData.content || ''
                    });
                } else {
                    setError("게시물 로드 실패: " + response.data.message);
                }
            } catch (error) {
                setError("API 요청 오류: " + error.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPost();
    }, [b_part, id]);
    
    // 입력 필드 변경 핸들러
    const handleChange = (e) => {
        const { name, value } = e.target;
        setPost(prev => ({
            ...prev,
            [name]: String(value)
        }));
    };
    
    // 취소 버튼 핸들러
    const handleCancel = () => {
        if (window.confirm('변경사항이 저장되지 않습니다. 취소하시겠습니까?')) {
            navigate(`/student-autonomy/${b_part}/detail/${id}`);
        }
    };

    const handleFileChange = (e) => {
        const selected = Array.from(e.target.files);
        if (files.length + selected.length > 10) {
            alert("첨부파일은 최대 10개까지 등록할 수 있습니다.");
            return;
        }
        setFiles(prev => [...prev, ...selected]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!post.title.trim()) {
            alert('제목을 입력해주세요.');
            return;
        }

        const formData = new FormData();
        formData.append("board", b_part);
        formData.append("id", id);
        formData.append("title", post.title);
        formData.append("content", post.content);
        files.forEach(file => formData.append("file", file));

        try {
            const response = await useApi_file.put('/update_board', formData);
            if (response.data.result === 'SUCCESS') {
                alert('게시글이 수정되었습니다.');
                navigate(`/student-autonomy/${b_part}/detail/${id}`);
            } else {
                setError("게시물 수정 실패: " + response.data.message);
            }
        } catch (error) {
            setError("API 요청 오류: " + error.message);
        }
    };

    
    if (isLoading) {
        return <Wrapper><p>로딩 중...</p></Wrapper>;
    }
    
    if (error) {
        return <Wrapper><p>오류: {error}</p></Wrapper>;
    }
    
    return (
        <Wrapper>
            <h2>게시글 수정</h2>
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                <FormGroup>
                    <Label htmlFor="title">제목</Label>
                    <Input
                        type="text"
                        id="title"
                        name="title"
                        value={post.title}
                        onChange={handleChange}
                    />
                </FormGroup>
                <FormGroup>
                    <Label htmlFor="content">내용</Label>
                    <TextArea
                        id="content"
                        name="content"
                        value={post.content}
                        onChange={handleChange}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>첨부파일 (기존 첨부파일은 삭제됩니다)</Label>
                    <Input type="file" multiple onChange={handleFileChange} />
                    <FileList>
                        {files.map((file, index) => (
                            <li key={index}>{file.name}</li>
                        ))}
                    </FileList>
                </FormGroup>
                <ButtonGroup>
                    <Button type="button" onClick={handleCancel}>취소</Button>
                    <Button type="submit" primary>저장</Button>
                </ButtonGroup>
            </form>
        </Wrapper>
    );
};

export default EditBoardPost;